import { pilotInformationSchema } from "../../forms/privateAviation/user/formSchema";
import PilotInformation from "../../forms/privateAviation/user/steps/pilotInformation/PilotInformation";
import EditSectionPage from "./EditSectionPage";

const PilotInformationEditPage = () => {
  return (
    <EditSectionPage
      title="Pilot Information"
      schema={pilotInformationSchema}
      step={5}
    >
      <PilotInformation />
    </EditSectionPage>
  );
};

export default PilotInformationEditPage;
